import { styled, Snackbar, css } from '@mui/material'
import Alert from '../Alert'
import { SnackbarStylesProps } from './Snackbar.types'

export const CustomSnackbar = styled(Snackbar)<SnackbarStylesProps>(
  ({ topOffset, bottomOffset }) => css`
    z-index: 9999;
    margin-top: ${topOffset ? topOffset - 8 : 0}px;
    margin-bottom: ${bottomOffset ? bottomOffset - 8 : 0}px;

    @media (min-width: 600px) {
      margin-top: ${topOffset ? topOffset - 24 : 0}px;
      margin-bottom: ${bottomOffset ? bottomOffset - 24 : 0}px;
    }
  `
)

export const SnackbarAlert = styled(Alert)(
  () => css`
    width: 100%;
  `
)
